import React from 'react';
import { createFromIconfontCN } from '@ant-design/icons';

import MOBILE_ICON from '@gp/assets/svg/platform/mobile.svg';
import PC_ICON from '@gp/assets/svg/platform/pc.svg';
import CONSOLE_ICON from '@gp/assets/svg/platform/console.svg';
import DOWNLOAD_ICON from '@gp/assets/svg/download.svg';
import GLOBAL16_ICON from '@gp/assets/svg/global-16.svg';

const PLATFORM_ICONS: Record<string, string> = {
  mobile: MOBILE_ICON,
  pc: PC_ICON,
  console: CONSOLE_ICON,
};

/**
 * 注意
 * 此组件icon链接pc/mobile用的同一地址，链接发生变化需要两端同步修改
 */
const SvgIcon = createFromIconfontCN({
  // @ts-ignore
  scriptUrl: import('@gp/assets/iconfont/iconfont.js'), // 在 iconfont.cn 上生成（下载到本地）
});

const ICON_MAP: any = {
  'download': DOWNLOAD_ICON,
  'menu-customized-global': GLOBAL16_ICON,
}

interface IconType {
  type?: string;
  className?: string;
  style?: React.CSSProperties;
}

export default function App(props: IconType) {
  const { type, className, style } = props;
  if (!type) return null;
  return (
    <>
      {
        ['mobile', 'pc', 'console'].includes(type?.toLowerCase())
          ? <img
              className={`svg-icon${className ? ` ${className}` : ''}`}
              style={style}
              src={PLATFORM_ICONS[type?.toLowerCase()]}
              alt=''
            />
          : ICON_MAP?.[type]
            ? <img
                className={`svg-icon${className ? ` ${className}` : ''}`}
                style={style}
                src={ICON_MAP?.[type]}
                alt=''
              />
            : <SvgIcon
                type={`icon-${type}`}
                className={`svg-icon${className ? ` ${className}` : ''}`}
                style={style}
              />
      }
    </>
  );
}
